@let post = block();
@let titleLevelData = titleLevel();

<a [routerLink]="post.full_slug | sbRouterLink | cachedUrlResolver"
   class="s1-article-preview--link"
   #linkRef>
    @if (post.content.image?.filename?.length) {
        <div class="relative h-24">
            <img class="s1-article-preview--image h-32 object-cover"
                 [ngSrc]="post.content.image!.filename"
                 fill
                 [alt]="post.content.image?.alt"
                 [title]="post.content.image?.title"
            >
        </div>
    }
    <div class="s1-article-preview--content">
        @switch (titleLevelData && +titleLevelData){
            @case (1){
                <h1>
                    {{post.content.title}}
                </h1>
            }
            @case (2){
                <h2>
                    {{post.content.title}}
                </h2>
            }
            @case (3){
                <h3>
                    {{post.content.title}}
                </h3>
            }

            @case (4){
                <h4>
                    {{post.content.title}}
                </h4>
            }
            @case (5){
                <h5>
                    {{post.content.title}}
                </h5>
            }
            @case (6){
                <h6>
                    {{post.content.title}}
                </h6>
            }
            @default {
                <h2>
                    {{post.content.title}}
                </h2>
            }

        }
        <p>
            {{post.content.description}}
        </p>
    </div>
</a>
